var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5V19M13.8128 14.6918L8.93042 17.8304C7.3245 18.8628 6.52153 19.379 5.85752 19.3316C5.27885 19.2903 4.74665 18.9997 4.39897 18.5353C4 18.0024 4 17.0478 4 15.1387V8.86133C4 6.95219 4 5.99762 4.39897 5.46471C4.74665 5.0003 5.27885 4.70974 5.85752 4.66841C6.52153 4.62099 7.3245 5.13718 8.93043 6.16956L13.8128 9.30823C15.2063 10.2041 15.9031 10.652 16.1438 11.2216C16.3541 11.7192 16.3541 12.2808 16.1438 12.7784C15.9031 13.348 15.2063 13.7959 13.8128 14.6918Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayNext);
export default __webpack_public_path__ + "static/media/play-next.97eab6e0d6cf5d5695f0626cc59aebfb.svg";
export { ForwardRef as ReactComponent };